
export interface Props{
  filters: any
}

export interface ResourceResponse {
  resources: Resource[]
  count: number
}

export interface Resource {
	author: Author
	id: string
  createdBy: {
    userId: string
    firstName: string
    lastName: string
  }
  createdAt: string
  researchFields: string[]
  title: string
  description: string
  downloadLink: string
  status: string
  _type: 'Text' |'Video'
}

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface TableData {
  author: string
  date: string
	id: string
  key: number
  status: string
  tags: string[]
  title: string
  type: 'Text' | 'Video'
}

export interface Author {
	firstName: string
	imageUrl: string
	isDeleted: boolean
	lastName: string
	role: string
	userId: string
}